<script lang="ts" setup>
import { computed } from 'vue'
import { LocationAsRelativeRaw, RouteLocationRaw, RouterLinkProps, useRoute } from 'vue-router'

export interface Props extends RouterLinkProps {
    to: RouteLocationRaw
    customActiveClass?: string
    noBackground?: boolean
    regularLink?: boolean
    noPadding?: boolean
}

const props = withDefaults(defineProps<Props>(), { noBackground: false, regularLink: false })
const emit = defineEmits<{ (e: 'click'): void }>()

const route = useRoute()
const active = computed(() => {
    const toName = ((props.to as LocationAsRelativeRaw)?.name || '') as string

    if (!toName) return false

    const currentRouteName = (route.name || '') as string

    const isCompanyRoute = toName === 'packaging.balance' || toName.endsWith('.companies')
    if (isCompanyRoute && currentRouteName.endsWith('customers.show')) {
        return true
    }

    return currentRouteName.includes(toName)
})
</script>

<template>
    <RouterLink
        :to="props.to"
        class="inline-flex items-center px-4 py-1.5 text-sm font-semibold transition-all duration-200 cursor-pointer rounded-md border-b-2"
        :class="{
            'bg-white dark:bg-dark-800 text-gray-900 dark:text-white shadow-sm border-yellow-500':
                active,
            'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white hover:bg-gray-300 dark:hover:bg-dark-700 border-transparent':
                !active,
        }"
        @click="emit('click')"
    >
        <slot />
    </RouterLink>
</template>
